/**
 * LOCATION_CHECK モジュール
 * - 現在のURLパスに基づいてナビゲーションリンクに aria-current="page" を付与
 */
export const LOCATION_CHECK = {
  init() {
    const menuSelector = '#menu-gnav'
    const pathParts = location.pathname.split('/').filter(Boolean)
    const slug = pathParts[0] // 例: /news/xxxx → "news"

    if (!slug) return

    // /news/slug の場合だけ deeper path を使う
    const subPath = slug === 'news' && pathParts[1] ? `/${pathParts[1]}` : ''
    const targetHref = `/${slug}${subPath}`

    const menu = document.querySelector(menuSelector)
    if (!menu) return

    const links = menu.querySelectorAll(`a[href*="${targetHref}"]`)
    links.forEach(link => {
      link.setAttribute('aria-current', 'page')
    })
  },
}
